import React from 'react'
import SvgIcon, { SvgIconProps } from 'components/Luxkit/SvgIcon'

function LineAutoTransmissionIcon(props: SvgIconProps) {
  return <SvgIcon {...props} fill="none" viewBox="0 0 24 24">
    <path fill="currentColor" fillRule="evenodd" d="M6.4443 3.6853a10 10 0 1 1 11.1114 16.6295A10 10 0 0 1 6.4443 3.6853Zm1.1111 14.9665a8.0005 8.0005 0 0 0 10.1015-.9949 8.0001 8.0001 0 1 0-10.1015.9949ZM12.144 6.3351a.9998.9998 0 0 0-1.0897.579l-3.6488 8.2272a.9999.9999 0 0 0 1.2739 1.3385.9999.9999 0 0 0 .5544-.5277l.4457-1.0049c.1023.0346.2105.0528.3206.0528h4c.1997 0 .3933-.0598.5568-.1694l.4974 1.1215a.9997.9997 0 0 0 1.3195.5088 1.0002 1.0002 0 0 0 .5087-1.3196l-3.6487-8.2272a1 1 0 0 0-1.0898-.579Zm0 3.055L13.7449 13H10.543l1.6009-3.6098Z" clipRule="evenodd"/>
  </SvgIcon>
}

export default LineAutoTransmissionIcon
